import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { Store } from 'src/app/core/store/store';
import { PartnerService } from 'src/app/shared/services/partner.service';

@Component({
  selector: 'app-learners',
  templateUrl: './learners.component.html',
  styleUrls: ['./learners.component.css']
})
export class LearnersComponent implements OnInit {
  public dropDownData: any = [
    { name: 'Program Completion: high to low', value: 'COMPLETION_HIGH_TO_LOW' },
    { name: 'Program Completion: low to high', value: 'COMPLETION_LOW_TO_HIGH' },
    { name: 'Program Score: high to low', value: 'SCORE_HIGH_TO_LOW' },
    { name: 'Program Score: low to high', value: 'SCORE_LOW_TO_HIGH' },
    { name: 'User Group: A to Z', value: 'USERGROUP_LOW_TO_HIGH' },
    { name: 'User Group: Z to A', value: 'USERGROUP_HIGH_TO_LOW' },

  ];
  email = '';
  selectedValue: any;
  page: any;
  courses: any = [
    { baseCampScore: 82, baseCampStatus: 'Completed', startDate: '10/12/2022', progress: 87, rating: '4.5/5', feedback: 'Thank you', scores: 82, status: 'Completed' }
  ];

  progColumns: any;
  headerColumns: any;
  learners: any;
  filteredLearners: any;
  searchQuery: string;
  learnersMap: any;
  currentOrganization: any;
  currentActivation: any;
  overallProgress: any;
  includeCourses: boolean;
  includeMasterclasses: boolean;
  includeAssessments: boolean;
  includeThriveDrills: boolean;

  progress = [0, 0, 0, 0, 0, 0, 0];

  spanMap = { PRE: 3, COURSE: 8, MASTERCLASS: 8, POST: 3, GENERAL: 8, ASSESSMENT : 4 };
  attrMap = {
    PRE: (i) => [
      {title: 'Score', type: 'score', key: `${i}_score`, origType: 'PRE'},
      {title: 'Status', type: 'iscompleted', key: `${i}_iscompleted`, origType: 'PRE'},
      {title: 'Time spent', type: 'spenttime', key: `${i}_spentTime`, origType: 'PRE'}
    ],
    COURSE: (i) => [
      {title: 'Start Date', type: 'item_start_date', key: `${i}_item_start_date`, origType: 'COURSE'}, {
      title: 'Progress',
      type: 'progress',
      key: `${i}_progress`,
      origType: 'COURSE'
    }, {title: 'Rating/5', type: 'rating', key: `${i}_rating`, origType: 'COURSE'}, {
      title: 'Review',
      type: 'item_review',
      key: `${i}_item_review`,
      origType: 'COURSE'
    }, {title: 'Score', type: 'score', key: `${i}_score`, origType: 'COURSE'}, {
      title: 'Status',
      type: 'iscompleted',
      key: `${i}_iscompleted`,
      origType: 'COURSE'
    }, {title: 'Completion Date', type: 'completedon', key: `${i}_completedon`, origType: 'COURSE'},
      {title: 'Time spent', type: 'spenttime', key: `${i}_spenttime`, origType: 'COURSE'}],
    MASTERCLASS: (i) => [
      {
      title: 'Start Date',
      type: 'item_start_date',
      key: `${i}_item_start_date`,
      origType: 'MASTERCLASS'
    },
      {title: 'Progress', type: 'progress', key: `${i}_progress`, origType: 'MASTERCLASS'}, {
      title: 'Rating/5',
      type: 'rating',
      key: `${i}_rating`,
      origType: 'MASTERCLASS'
    }, {title: 'Review', type: 'item_review', key: `${i}_item_review`, origType: 'MASTERCLASS'}, {
      title: 'Status',
      type: 'iscompleted',
      key: `${i}_iscompleted`,
      origType: 'MASTERCLASS'
    }, {title: 'Completion Date', type: 'completedon', key: `${i}_completedon`, origType: 'MASTERCLASS'},
      {title: 'Session Attendance Time', type: 'attendeLiveDuration', key: `${i}_attendeLiveDuration`, origType: 'MASTERCLASS'},
      {title: 'Recording Watched Time', type: 'spenttime', key: `${i}_spenttime`, origType: 'MASTERCLASS'}],
    POST: (i) => [
      {title: 'Score', type: 'score', key: `${i}_score`, origType: 'POST'},
      {
      title: 'Status',
      type: 'iscompleted',
      key: `${i}_iscompleted`,
      origType: 'POST'
    },
      {
        title: 'Time spent', type: 'spenttime', key: `${i}_spenttime`,
      origType: 'POST'
    }],
    ASSESSMENT: (i) => [
      {
      title: 'Start Date',
      type: 'item_start_date',
      key: `${i}_item_start_date`,
      origType: 'ASSESSMENT'
    },
      {title: 'Status', type: 'iscompleted', key: `${i}_iscompleted`, origType: 'ASSESSMENT'},
      {title: 'Time spent', type: 'spenttime', key: `${i}_spenttime`, origType: 'ASSESSMENT'},
      {title: 'Score', type: 'score', key: `${i}_score`, origType: 'ASSESSMENT'}]
  };


  sortCriteriaMap: any = {
    COMPLETION_HIGH_TO_LOW: (a, b) => (a[5] > b[5]) ? -1 : (a[5] < b[5]) ? 1 : 0,
    COMPLETION_LOW_TO_HIGH: (a, b) => (a[5] > b[5]) ? 1 : (a[5] < b[5]) ? -1 : 0,
    SCORE_HIGH_TO_LOW: (a, b) => (a[6] > b[6]) ? -1 : (a[6] < b[6]) ? 1 : 0,
    SCORE_LOW_TO_HIGH: (a, b) => (a[6] > b[6]) ? 1 : (a[6] < b[6]) ? -1 : 0,
    USERGROUP_LOW_TO_HIGH: (a, b) => (a[4] > b[4]) ? 1 : (a[4] < b[4]) ? -1 : 0,
    USERGROUP_HIGH_TO_LOW: (a, b) => (a[4] > b[4]) ? -1 : (a[4] < b[4]) ? 1 : 0,
  };
  userTimezone: string;


  constructor(private store: Store, private partnerService: PartnerService, private datePipe: DatePipe) { }
  ProgramSummarys: any[];
  readMore = false;
  hideme = [];
  displayStyle = 'none';
  show = false;
  showCourseFilter = false;
  showMasterclassFilter = false;
  showPrePostFilter = false;
  showAssessmentFilter = false;
  config = {
    value: false,
    name: '',
    disabled: false,
    height: 25,
    width: 50,
    margin: 3,
    fontSize: 10,
    speed: 300,
    color: {
      checked: '#56C128',
      unchecked: '#dcdcdc'
    },
    switchColor: {
      checked: '#3366FF',
      unchecked: 'crimson'
    },
    labels: {
      unchecked: 'off',
      checked: 'on'
    },
    checkedLabel: '',
    uncheckedLabel: '',
    fontColor: {
      checked: '#fafafa',
      unchecked: '#ffffff'
    }
  };
  ngOnInit(): void {

    this.includeAssessments = true;
    this.includeCourses = true;
    this.includeMasterclasses = true;
    this.includeThriveDrills = true;

    this.store.select<string>('currentOrganization').pipe(distinctUntilChanged()).subscribe((organization) => {
      this.currentOrganization = organization;
    });

    this.store.select<string>('userTimeZone').pipe(distinctUntilChanged()).subscribe((timezone) => {
      this.userTimezone = timezone;
      this.createFilteredLearners();
    });

    this.store.select<string>('currentActivationTitle').pipe(distinctUntilChanged()).subscribe((activation) => {
      this.currentActivation = activation;
    });


  }
  secondsToMinAndHours(secs: number): string{
    let finalString = '';
    if ( secs > 3600){
      const hours = Math.round(secs / 3600);
      finalString += `${hours} h `;
    }
    const min = Math.round((secs % 3600) / 60);
    finalString += `${min} ${min > 1 ? 'mins' : 'min'}`;
    return finalString;
  }
  createFilteredLearners(){
    this.store.select<any>('metrics').pipe(distinctUntilChanged()).subscribe((metrics) => {
      this.learnersMap = {};

      if (metrics?.learners) {
        metrics.learners.forEach((l) => {
          this.learnersMap[l.userid] = {
            name: l.firstname && l.lastname ? `${l.firstname} ${l.lastname}` : l.firstname ? l.firstname : l.lastname,
            program_progress: l.progress ? Math.floor(l.progress.toFixed(1)) : 0,
            // firstLogin: this.getLongDateStringWithTime(l.firstlogintime),
            firstLogin: this.convertUnlockDateTimeString(this.convertMasterClassTime(l.firstlogintime, this.userTimezone)),
            // lastLogin: this.getLongDateStringWithTime(l.lastlogindate),
            lastLogin: this.convertUnlockDateTimeString(this.convertMasterClassTime(l.lastlogindate, this.userTimezone)),
            usergroup: l.usergroup,
            email: l.email,
            program_rating: l.rating ? `${l.rating}` : 'NA',
            program_score: l.programpercentage ? Math.floor(l.programpercentage.toFixed(1)) : -1,
          };
        });
      }


    });
    this.store.select<any>('elements').pipe(distinctUntilChanged()).subscribe((elements) => {

      if (elements?.learnerDetails) {
        const topCols = [];
        let titleCols = [];
        let learnersIndex = 0;
        const learnersMap = {};
        const localLearners = [];
        // console.log(elements, 'elements');
        elements.learnerDetails.forEach((l) => {
          if (this.attrMap[l?.type]){
            const today = moment().valueOf();
            if (topCols.length === 0 || topCols[topCols.length - 1].title !== l.item_title) {

              if (topCols.length === 0) {
                topCols.push({type: 'GENERAL', span: this.spanMap.GENERAL, title: ''});
                titleCols = [...titleCols, {title: 'Name', type: 'string', key: 'name'}, {title: 'Email', type: 'string', key: 'email'},
                  {title: 'First Login', type: 'string', key: 'firstLogin'}, {title: 'Last Login', type: 'string', key: 'lastLogin'},
                  {title: 'User Group', type: 'string', key: 'usergroup'}, {
                    title: 'Program Progress',
                    type: 'progress',
                    key: 'program_progress'
                  }, {title: 'Program Score', type: 'score', key: 'program_score'}, {
                    title: 'Program Rating/5',
                    type: 'rating',
                    key: 'program_rating'
                  }];
              }
              // if (topCols[topCols.length - 1].title !== l.item_title) {
              if (!topCols.find(q => q.title == l.item_title)) {
                learnersIndex = learnersIndex + 1;
                topCols.push({type: l.type, span: this.spanMap[l.type], title: l.item_title});
                titleCols = [...titleCols, ...this.attrMap[l?.type](learnersIndex)];

              }
            }

            if (!learnersMap[l.userid]) {
              const basicInfo = this.learnersMap[l.userid];
              learnersMap[l.userid] = basicInfo;
            }

            const ll = learnersMap[l.userid];
            const cols = this.attrMap[l.type](learnersIndex);
            cols.forEach((c) => {
              let t = l[c.type];
              if (c.type === 'score' || c.type === 'progress') {
                t = t !== null ? Math.round(t) : -1;
              }
              if (c.type === 'spenttime') {
                t = t ? this.secondsToMinAndHours(t) : '-';
              }
              if (c.type === 'attendeLiveDuration') {
                t = t ? this.secondsToMinAndHours(t) : '-';
              }

              if (c.type === 'iscompleted') {
                if (l.type === 'PRE' || l.type === 'POST') {
                  t = t ? 'Completed' : 'Not Started';
                } else {
                  let startedOn = l.item_start_date;
                  startedOn = parseInt(startedOn);
                  if (!isNaN(startedOn) && startedOn > today) {
                    t = 'Locked';
                  } else {

                    let p = l.progress;
                    p = p ? Math.round(p) : 0;
                    t = p === 100 ? 'Completed' : p === 0 ? 'Not Started' : 'Ongoing';

                  }
                }
              }

              if (c.type === 'rating') {
                t = t ? `${t}` : 'NA';
              }

              if (c.type === 'item_start_date') {
                if (t?.includes(' - Default')) {
                  const pattern = /( \- Default)/g;
                  t = this.datePipe.transform(t?.replace(pattern, ''), 'd MMM y');
                }
                if (l?.type == 'MASTERCLASS') {
                  t = t ? this.datePipe.transform(t, 'dd MMM yyyy') : 'NA';
                } else {
                  t = t ? this.getLongDateStringWithoutTime(t) : 'NA';
                }

              }

              if (c.type === 'completedon') {
                // t = t ? this.getLongDateStringWithTime(t) : 'NA';
                t = t ? this.convertUnlockDateTimeString(this.convertMasterClassTime(t, this.userTimezone)) : 'NA';
              }

              ll[c.key] = t;
            });
            learnersMap[l.userid] = ll;
          }
        });


        const values = Object.values(learnersMap);

        if (values && values.length > 0) {
          values.forEach((v) => {
            const l = [];

            titleCols.forEach((col) => {
              l.push(v[col.key]);
            });
            localLearners.push(l);
          });

          this.learners = localLearners;
          this.filteredLearners = this.learners;
          // console.log('filtered learners: ', this.filteredLearners);

        }

        this.progColumns = topCols;
        this.headerColumns = titleCols;
        // console.log(this.headerColumns);
        for (let i = 0; i < this.progColumns.length; i++) {
          if (this.progColumns[i].type === 'COURSE') {
            this.showCourseFilter = true;
          } else if (this.progColumns[i].type === 'MASTERCLASS') {
            this.showMasterclassFilter = true;
          } else if (this.progColumns[i].type === 'PRE' || this.progColumns[i].type === 'POST') {
            this.showPrePostFilter = true;
          } else if (this.progColumns[i].type === 'ASSESSMENT') {
            this.showAssessmentFilter = true;
          }
        }

        this.progress = this.partnerService.calculateOverallProgress(elements);



      }
    });
  }

  convertMasterClassTime(time, zone){
    const d = new Date(parseInt(time));
    const inititalDate = new Date(d.setUTCMinutes(d.getUTCMinutes() + d.getTimezoneOffset()));
    return new Date(inititalDate.setUTCMinutes(inititalDate.getUTCMinutes() + this.convertMinutes(zone))).getTime().toString();
  }

  convertUnlockDateTimeString(time){
    if (isNaN(time)) {
      return 'NA';
    }
   else {
      return new Date(parseInt(time)).toLocaleDateString('en', { year: 'numeric', month: 'short' , day: '2-digit' , hour: '2-digit', minute: '2-digit'});
    }

}

  convertMinutes(time){
    if (time){
      const timeParts = time.split(':');
      return Number(timeParts[0]) * 60 + Number(timeParts[1]);
    }

  }

  onSortChange(sortCriteria: string, selected: string) {
    this.learners = this.learners ? this.learners.sort(this.sortCriteriaMap[sortCriteria]) : [];
    this.filteredLearners = this.learners;
    this.selectedValue = selected;
    if (sortCriteria === 'COMPLETION_HIGH_TO_LOW'){
      this.learners = this.learners ? this.learners.sort((a, b) => (b.progress - a.progress || a.completedon - b.completedon)) : [];
    }
    if (sortCriteria === 'COMPLETION_LOW_TO_HIGH'){
      this.learners = this.learners ? this.learners.sort((a, b) => (a.progress - b.progress || a.completedon - b.completedon)) : [];
    }
  }

  getLongDateStringWithTime(dateNode) {

    if (dateNode) {
      const date = parseInt(dateNode);
      return moment(date).format('DD MMM YYYY hh:mm A');
    }
    else {
      return '-';
    }
  }

  getLongDateStringWithoutTime(dateNode) {
    if (dateNode) {
      const date = parseInt(dateNode);
      if (isNaN(date)){
        return dateNode ? dateNode : '-';
      }
      return moment.utc(dateNode).format('DD MMM YYYY');
    }
    else {
      return '-';
    }
  }

  search(event) {
    this.searchQuery = event.target.value ? event.target.value.toLowerCase() : '';

    if (this.searchQuery) {
      this.filteredLearners = this.learners.filter((l) => l[0]?.toLowerCase().indexOf(this.searchQuery) !== -1 || l[1]?.toLowerCase().indexOf(this.searchQuery) !== -1);
    }
    else {
      this.filteredLearners = this.learners;
    }
  }

  downloadReport = () => {


    const filename = `Harappa | ${this.currentOrganization} | ${this.currentActivation} | Learners`;
    const cols = this.headerColumns.map((h) => h.title);
    const merge = [];
    const headerCols = [];
    let colStart = 0;
    this.progColumns.forEach((p) => {
      merge.push({ s: { r: 0, c: colStart }, e: { r: 0, c: colStart + p.span - 1 } });
      colStart = colStart + p.span;
      for (let i = 0; i < p.span; i++) {
        if (i === 0) {
          headerCols.push(`${p.type !== 'GENERAL' && p.type !== 'PRE' && p.type !== 'POST' ? '(' + p.type + ') ' + p.title : p.type === 'PRE' || p.type === 'POST' ? p.title : ''}`);
        }
        else {
          headerCols.push('');
        }
      }
    });

    const aoaProgress = [
      ['Overall Program', this.progress[0]],
      ['Pre-assessment', this.progress[1]],
      ['Unlocked Live Sessions', this.progress[4]],
      ['Unlocked Courses', this.progress[3]],
      ['Post-assessment', this.progress[2]],
      ['Unlocked Habit Drills', this.progress[5]],
      ['Unlocked Thrive Drills', this.progress[6]],
    ];

    const sanitizedLearners = this.learners.map((l) => {
       return l.map((a) => {
          if (a === -1){
            return 'NA';
          }
          return a;
       });
    });

    this.partnerService.downloadXlsxAoa([headerCols, cols, ...sanitizedLearners], filename, merge, aoaProgress.filter((a) => a[1] >= 0));
    // this.partnerService.downloadFile([headerCols, cols, ...this.learners], [], filename, true);
  }




  expand(currentEle: any) {
    // console.log('Element this', currentEle);
  }
  toggleSwitch(event: any, element: string) {
    this.includeAssessments = (element === 'assessments') ? event : this.includeAssessments;
    this.includeCourses = (element === 'course') ? event : this.includeCourses;
    this.includeMasterclasses = (element === 'masterclass') ? event : this.includeMasterclasses;
    this.includeThriveDrills = (element === 'thrive drill') ? event : this.includeThriveDrills;
  }
}
